export const ContentMessageDefault = (props) => {
  const { subject = "World Vision Community Registration Error" } = props;

  return (
    <p className="base p-xl">
      If you are still having issues logging in, please email us at &nbsp;
      <a
        className="btn-text-blue"
        href={`mailto:community@worldvision.org?subject=${subject}`}
        target="_blank">
        community@worldvision.org
      </a>
      , and we can help.
    </p>
  );
};

export default ContentMessageDefault;
